var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWebSite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "15px",
    viewBox: "0 0 19 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_web_site") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CleverSparky-Web-App-V2.0---UI-Updates-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Support",
    transform: "translate(-18.000000, -238.000000)",
    stroke: "#666162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_web_app",
    transform: "translate(18.000000, 238.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,11.5 L4,11.5",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,9.5 L4,9.5",
    id: "Stroke-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,7.5 L4,7.5",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4761905,13.5 C18.4761905,14.05 18.0047619,14.5 17.4285714,14.5 L1.57142857,14.5 C0.995238095,14.5 0.523809524,14.05 0.523809524,13.5 L0.523809524,1.5 C0.523809524,0.95 0.995238095,0.5 1.57142857,0.5 L17.4285714,0.5 C18.0047619,0.5 18.4761905,0.95 18.4761905,1.5 L18.4761905,13.5 Z",
    id: "Stroke-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,4.5 L18,4.5",
    id: "Stroke-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14285714,2.5 C3.14285714,2.776 2.90819048,3 2.61904762,3 C2.32990476,3 2.0952381,2.776 2.0952381,2.5 C2.0952381,2.224 2.32990476,2 2.61904762,2 C2.90819048,2 3.14285714,2.224 3.14285714,2.5 Z",
    id: "Stroke-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,5 L5.5,14",
    id: "Stroke-10"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebSite);
export default __webpack_public_path__ + "static/media/icon-web-site.62daaa20493c853b72746238a8bc71ad.svg";
export { ForwardRef as ReactComponent };